import { render, staticRenderFns } from "./myCreation.vue?vue&type=template&id=36c09fbe&scoped=true&"
import script from "./myCreation.vue?vue&type=script&lang=ts&"
export * from "./myCreation.vue?vue&type=script&lang=ts&"
import style0 from "./myCreation.vue?vue&type=style&index=0&id=36c09fbe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c09fbe",
  null
  
)

export default component.exports